export default "__VITE_ASSET__c2cfbca9__"